/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */
import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function SetSectionSettingsReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeSetSectionSettingsAction } action: action
 *     de l'application
 * @return { Reducer }
 */
export const SetSectionSettingsReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeSetSectionSettingsAction) => {
      switch (action.type) {
        case actions.SetSectionSettingsActionTypes
            .SETSECTIONSETTINGS_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.SetSectionSettingsActionTypes.SETSECTIONSETTINGS_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.SetSectionSettingsActionTypes.SETSECTIONSETTINGS_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        case actions.SetSectionSettingsActionTypes.SETSECTIONSETTINGS_RESET:

          return {
            state: {}
          }

          break;

        default:
          return state
          break;
      }
    }



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/supervision/systems/setsectionsettings/index.ts